var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadUsage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92507 11.2334C1.56527 11.2334 1.25726 11.1053 1.00103 10.8491C0.74481 10.5929 0.616699 10.2849 0.616699 9.92507V7.96251H1.92507V9.92507H9.77529V7.96251H11.0837V9.92507C11.0837 10.2849 10.9555 10.5929 10.6993 10.8491C10.4431 11.1053 10.1351 11.2334 9.77529 11.2334H1.92507ZM5.85018 8.6167L2.57925 5.34577L3.49511 4.39721L5.19599 6.09809V0.766479H6.50436V6.09809L8.20525 4.39721L9.1211 5.34577L5.85018 8.6167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadUsage);
export default __webpack_public_path__ + "static/media/DownloadUsage.fc29cd2c234fd84fe4be59694f5f18da.svg";
export { ForwardRef as ReactComponent };